<h2 mat-dialog-title class="text-center">
  {{ 'unsub_confirm_title' | translate }}
</h2>

<mat-dialog-content class="mt-2 text-center">
  <p>
    {{ 'unsub_confirm_message_1' | translate }}<br />
    {{ 'unsub_confirm_message_2' | translate }}
  </p>
</mat-dialog-content>

<mat-dialog-actions class="mt-3 justify-center">
  <button mat-button mat-dialog-close>
    {{ 'unsub_button_no' | translate }}
  </button>

  <button mat-raised-button color="warn" (click)="confirm()">
    {{ 'unsub_button_yes' | translate }}
  </button>
</mat-dialog-actions>
